<ion-modal #optionsModal (didDismiss)="onCancel()">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="onCancel()">Cancelar</ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button (click)="onConfirm()">Listo</ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-toolbar color="primary">
        <ion-searchbar
        placeholder="Buscar"
        [(ngModel)]="searchTerm"
        (ionInput)="onSearchChange($event)">
      </ion-searchbar>
      </ion-toolbar>
    </ion-header>

    <ion-content>

      <ion-list id="modal-list" [inset]="true">

        <!-- multiple selection -->
        <ng-container *ngIf="multiple">
          <ion-item *ngFor="let opt of filteredOptions">
            <ion-checkbox
              [value]="opt"
              [checked]="isChecked(opt)"
              (ionChange)="checkboxChange($event)">
              {{ opt }}
            </ion-checkbox>
          </ion-item>
        </ng-container>

        <!-- single selection -->
        <ng-container *ngIf="!multiple">
          <ion-radio-group
            [value]="selectedValues[0]"
            (ionChange)="onSingleSelect($event)">
            <ion-item *ngFor="let opt of filteredOptions">
              <ion-label>{{ opt }}</ion-label>
              <ion-radio slot="end" [value]="opt"></ion-radio>
            </ion-item>
          </ion-radio-group>
        </ng-container>

      </ion-list>


    </ion-content>
  </ng-template>
</ion-modal>
